<template>
  <div class="log">
    <el-menu :default-active="activeSelect" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">登录记录</el-menu-item>
      <el-menu-item index="2">操作记录</el-menu-item>
    </el-menu>
    <div v-if="activeSelect === '1'" class="log_box" v-loading='loading'>
      <div class="permissions_box_table">
        <template>
          <el-table :data="autList" border style="width: 100%">
            <el-table-column label="专家" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.Name}}</template>
            </el-table-column>
            <el-table-column label="KID" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.KId}}</template>
            </el-table-column>
            <el-table-column label="机构" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.Organization}}</template>
            </el-table-column>
            <el-table-column label="授权用户名" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.PermitUserName}}</template>
            </el-table-column>
            <el-table-column label="操作"  width="300">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="dialogFormVisibleAutView = true; aut = scope.row"
                  size="mini"
                >查看权限</el-button>
                <el-button
                  type="warning"
                  @click="dialogFormVisibleAutEdit = true; aut = scope.row; "
                  size="mini"
                >修改权限</el-button>
                <el-button type="danger" @click="delAut(scope.row)" size="mini">取消授权</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <pagination
        :total="pageData1.total"
        :page.sync="pageData1.PageIndex"
        :limit.sync="pageData1.PageSize"
        :pageSizes="pageData1.PageSizes"
        :layout="layout"
        @pagination="getPage1"
      />
    </div>
    <div v-if="activeSelect === '2'" class="log_box" v-loading='loading'>

      <div class="permissions_box_table">
        <template>
          <el-table :data="expList" border style="width: 100%">
            <el-table-column label="专家" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.Name}}</template>
            </el-table-column>
            <el-table-column label="KID" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.ManagedExpert.KId}}</template>
            </el-table-column>
            <el-table-column label="机构">
              <template slot-scope="scope">{{scope.row.ManagedExpert.Organization || '暂无机构信息'}}</template>
            </el-table-column>
            <el-table-column label="已授权">
              <template slot-scope="scope">
                <span
                  v-for="item in scope.row.Permissions"
                  :key="item"
                  style="margin-right:10px"
                >{{item.Name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button type="danger" @click="claim(scope.row)" size="mini">成果认领</el-button>
                <el-button type="warning" @click="management(scope.row)" size="mini">成果管理</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <pagination
        :total="pageData2.total"
        :page.sync="pageData2.PageIndex"
        :limit.sync="pageData2.PageSize"
        :pageSizes="pageData2.PageSizes"
        :layout="layout"
        @pagination="getPage2"
      />
    </div>
  </div>
</template>

<script>
import {
  getLog
} from '@/api/center'
import Pagination from '@/components/Pagination'
export default {
  name: 'focus',
  components: {
    Pagination
  },
  props: {
    isHttp: {
      type: String
    }
  },
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      activeSelect: '1',
      autList: [],
      expList: [

      ],
      orgList: [],
      perList: [
        '简历管理',
        '履历管理',
        '历史成果管理',
        '新增成果管理',
        '成果内容管理',
        '关注量统计查看'
      ],
      aut: {},
      expName1: '',
      expName2: '',
      userName: '',
      options: [{ name: '浙江大学' }],
      org: '浙江大学',
      checkList: [],
      pageData1: {
        total: '',
        PageIndex: 1,
        PageSize: 12,
        pageSizes: [12]
      },
      pageData2: {
        total: '',
        PageIndex: 1,
        PageSize: 12,
        pageSizes: [12]
      },
      pageData3: {
        total: '',
        PageIndex: 1,
        PageSize: 12,
        pageSizes: [12]
      },
      layout: 'sizes, prev, pager, next, jumper',
      dialogFormVisibleAut: false,
      dialogFormVisibleAutView: false,
      dialogFormVisibleAutEdit: false,
      loading: false
    }
  },
  methods: {
    handleSelect (index) {
      this.activeSelect = index
    },
    getLog () {
      let data = {
        Category: '3001',
        OperatorId: '',
        PageSize: this.pageData1.PageSize,
        PageIndex: this.pageData1.PageIndex
      }
      getLog(data).then(res => {

      })
    }
  },
  watch: {
    isHttp: {
      deep: true,
      handler (val) {
        if (val === 4) {
          this.getLog()
          this.activeSelect = '1'
        }
      }
    }
  },
  mounted () {}
}
</script>

<style lang="scss">
.log {
  .log {
    padding: 0 40px;
    .permissions_box_header {
      width: 100%;
      padding: 20px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .permissions_box_header_searchInfo {
        width: 60%;
        .el-input {
          width: 30%;
        }
        .el-select {
          width: 30%;
          margin-right: 20px;
          .el-input--suffix {
            width: 100%;
          }
        }
      }
    }
  }
  .el-dialog {
    .dialog_aut {
      .el-input {
        width: 80%;
        margin-right: 20px;
      }
    }
    .dialog_autView {
      font-size: 1.1rem;
      padding: 0 10%;
      .autInfo {
        margin: 20px 0;
        display: flex;
        flex-direction: row;
        .autInfoRow {
          width: 80%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }
        lable {
          display: inline-block;
          text-align: right;
          width: 15%;
        }
        .el-checkbox-group {
          width: 80%;
          .el-checkbox__label {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/log.vue